export function getTodayYYYYMMDD(): string {
  const now = new Date();
  const yyyy = String(now.getFullYear());
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function toTimestampMs(value: string | null | undefined): number | null {
  if (!value) return null;
  const ms = Date.parse(value);
  return Number.isFinite(ms) ? ms : null;
}

export function formatDateTimeLabel(value: string): string {
  const ms = toTimestampMs(value);
  if (ms === null) return value;

  try {
    return new Date(ms).toLocaleString([], {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return value;
  }
}

export function toDayKeyYYYYMMDD(value: string | null | undefined): string | null {
  if (!value) return null;
  const match = value.match(/^\d{4}-\d{2}-\d{2}/);
  return match ? match[0] : null;
}

export function formatDayLabel(dayKey: string | null): string {
  return dayKey === null ? 'Unknown date' : dayKey;
}

const MS_PER_SECOND = 1000;
const MS_PER_MINUTE = 60 * MS_PER_SECOND;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;

export function formatRelativeAgeLabel(
  value: string | null | undefined,
  nowMs: number = Date.now()
): string | null {
  const valueMs = toTimestampMs(value);
  if (valueMs === null) return null;

  const ageMs = Math.max(0, nowMs - valueMs);

  if (ageMs < MS_PER_MINUTE) {
    const seconds = Math.floor(ageMs / MS_PER_SECOND);
    return seconds === 1 ? '1 second old' : `${seconds} seconds old`;
  }
  if (ageMs < MS_PER_HOUR) {
    const minutes = Math.floor(ageMs / MS_PER_MINUTE);
    return minutes === 1 ? '1 minute old' : `${minutes} minutes old`;
  }
  if (ageMs < MS_PER_DAY) {
    const hours = Math.floor(ageMs / MS_PER_HOUR);
    return hours === 1 ? '1 hour old' : `${hours} hours old`;
  }

  const days = Math.floor(ageMs / MS_PER_DAY);
  return days === 1 ? '1 day old' : `${days} days old`;
}

const MS_PER_WEEK = 7 * MS_PER_DAY;

export function formatRelativeTimeShort(
  timestampMs: number | null | undefined,
  nowMs: number = Date.now()
): string | null {
  if (timestampMs == null || !Number.isFinite(timestampMs)) return null;

  const ageMs = Math.max(0, nowMs - timestampMs);

  if (ageMs < MS_PER_MINUTE) return 'just now';
  if (ageMs < MS_PER_HOUR) return `${Math.floor(ageMs / MS_PER_MINUTE)}m ago`;
  if (ageMs < MS_PER_DAY) return `${Math.floor(ageMs / MS_PER_HOUR)}h ago`;
  if (ageMs < MS_PER_WEEK) return `${Math.floor(ageMs / MS_PER_DAY)}d ago`;

  const weeks = Math.floor(ageMs / MS_PER_WEEK);
  return weeks <= 4 ? `${weeks}w ago` : `${Math.floor(ageMs / (MS_PER_DAY * 30))}mo ago`;
}
